import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-survey-history',
  templateUrl: './survey-history.component.html',
  styleUrls: ['./survey-history.component.css']
})
export class SurveyHistoryComponent implements OnInit {

    @Input() id: any;

    public accordian_s = false;

    public surveyHistory: any[] = [
        {
            serviceDate: '03/12/2024',
            surveyRequestedDate: '03/14/2024',
            surveyDetailsShared: 'Yes',
            surveySent: 'Yes',
            surveySentDate: '03/15/2024'
        }
    ];

    constructor() { }

    ngOnInit() { }
}



// WEBPACK FOOTER //
// ./src/app/modules/housekeeping/utility/survey-history/survey-history.component.ts